<template>
  <el-button round size="small" class="theme flex_c md_r05" @click="toZoom">
    <div class="flex_c">
      <img src="../assets/meetings.png" class="flex_c" style="height:1.2rem;">
      <img src="../assets/ZoomLogo.png" class="flex_c" style="height:0.8rem;padding-left:0.2rem;">
    </div>
  </el-button>
</template>
<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState(['session', 'user'])
  },
  methods: {
    toZoom() {
      const userName = this.user?.nickname || this.user?.name || '';
      const url = location.origin + '/livekit?name=' + encodeURIComponent(userName) + '&sid=' + this.session.sid;
      this.$store.commit('setMeeting', {
        active: true,
        minimized: false,
        url: url,
        name: userName
      });
    },
  }
}
</script>